<script setup lang="ts">
import { computed } from "vue";
const props = withDefaults(
  defineProps<{ tone?: "neutral" | "success" | "warning" | "danger" }>(),
  { tone: "neutral" },
);
const cls = computed(() => ["cw-toast", `cw-toast--${props.tone}`]);
</script>
<template>
  <div
    :class="cls"
    role="status"
  >
    <slot />
  </div>
</template>
